const isImageLoaded = ($img) => {
	if (!$img.complete) return false;
	if (typeof $img.naturalWidth !== 'undefined' && $img.naturalWidth === 0) return false;
	return true;
};

const imageSizeTranslation = (columnWidth = '', imageObj, seperator = '-', lazyLoad = true, limitLower = false, imageWidth = false) => {
	const returnObj = {};
	const useLazy = lazyLoad !== false;
	let width = 1;
	columnWidth = columnWidth.toString();
	if (!imageObj || Object.keys(imageObj).length === 0) return {};
	if (imageObj.src) imageObj.url = imageObj.src;
	if (/\.(svg|gif)$/.test(imageObj.url)) columnWidth = 'noResize';
	const imageName = imageObj.url.slice(0, imageObj.url.lastIndexOf('.'));
	const imageExt = imageObj.url.slice(imageObj.url.lastIndexOf('.'));

	if (useLazy && lazyLoad === 'eager') returnObj.loading = 'eager';
	else if (useLazy) returnObj.loading = 'lazy';
	if (imageWidth !== false) {
		returnObj.src = `${imageName}${seperator}${imageWidth}x${imageExt}`;
		returnObj.alt = imageObj.alt;
		returnObj.width = imageWidth;
		if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * imageWidth);
		return returnObj;
	}

	switch (columnWidth) {
		case 'full':
		case '12':
		case '11':
		case '10':
			width = 2600;
			returnObj.src = `${imageName}${seperator}2600x${imageExt}`;
			returnObj.srcSet = `${imageName}${seperator}2000x${imageExt} 2000w, ${imageName}${seperator}1600x${imageExt} 1600w, ${imageName}${seperator}1200x${imageExt} 1200w${(limitLower ? '' : `, ${imageName}${seperator}800x${imageExt} 800w, ${imageName}${seperator}400x${imageExt} 400w`)}`;
			break;
		case '9':
		case '8':
		case '7':
			width = 1800;
			returnObj.src = `${imageName}${seperator}1800x${imageExt}`;
			returnObj.srcSet = `${imageName}${seperator}1200x${imageExt} 1200w${(limitLower ? '' : `, ${imageName}${seperator}800x${imageExt} 800w, ${imageName}${seperator}400x${imageExt} 400w`)}`;
			break;
		case '6':
		case '5':
		case '4':
			width = 1200;
			returnObj.src = `${imageName}${seperator}1200x${imageExt}`;
			returnObj.srcSet = `${imageName}${seperator}800x${imageExt} 800w, ${imageName}${seperator}400x${imageExt} 400w`;
			break;
		case '3':
		case '2':
		case '1':
			width = 800;
			returnObj.src = `${imageName}${seperator}800x${imageExt}`;
			returnObj.srcSet = `${imageName}${seperator}400x${imageExt} 400w`;
			break;
		default:
			width = imageObj.width;
			returnObj.src = imageObj.url;
	}
	returnObj.alt = imageObj.alt;
	returnObj.width = width;
	if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * width);

	return returnObj;
};

export { isImageLoaded, imageSizeTranslation };
